module.exports = __webpack_public_path__ + "e92e225d3607e581a40768722efe9a5f.svg";